module.exports = __webpack_public_path__ + "img/yarn.7075295c.svg";